module.exports = __webpack_public_path__ + "media/images/email_logo-19438a686759faf4e84b39c927c30011.svg";